import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-deployment",
  "use": "icon-deployment-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-deployment\"><path d=\"m14 8.6 5.2 5.2-1.4 1.4-2.8-2.8V26h-2V12.4l-2.8 2.8-1.4-1.4zM15 0c4.2 0 7.6 3.2 8 7.2 2.8.6 5 3.2 5.2 6.4 0 3.6-3 6.6-6.6 6.6H18v-2h3.6c2.6 0 4.6-2.2 4.6-4.6 0-2.2-1.6-4-3.6-4.4l-1.4-.4-.2-1.4c-.4-3-3-5.4-6-5.4-2.8 0-5.2 1.8-5.8 4.4L8.8 8H7c-2.8 0-5 2.2-5 5s2.2 5 5 5h3v2H7c-3.8 0-7-3.2-7-7s3.2-7 7-7h.2c1-3.4 4-6 7.8-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol